import { defineStore } from 'pinia'
import { NAME } from './storeName'
import { Ipvm } from '@/types/response'
import { computed, ref } from 'vue'

type ApparatusMonitorState = {
  query: {
    isPersonal: boolean
  }
}
export type IApparatusCountState = {
  Desktop: number
  'E-business': number
  Generic: number
  Gpu: number
  Game: number
  App: number
}

const DEFAULT_APP_COUNT = {
  Desktop: 0,
  'E-business': 0,
  Generic: 0,
  Gpu: 0,
  Game: 0,
  App: 0,
}

export const useApparatusStore = defineStore(NAME.APPARATUS, {
  state: () => {
    return {
      apparatusCount: DEFAULT_APP_COUNT,
    }
  },
  // persist: true,
  actions: {
    setCount(result?: Ipvm[]) {
      result =
        result &&
        result.filter((item) => {
          return item.status !== 'Deleting'
        })
      this.apparatusCount = Object.assign({}, DEFAULT_APP_COUNT)
      this.apparatusCount =
        result &&
        result.length > 0 &&
        result.reduce((pre: IApparatusCountState, value: Ipvm) => {
          if (
            Object.keys(DEFAULT_APP_COUNT).includes(
              value?.size?.scene as keyof IApparatusCountState,
            )
          ) {
            pre[value?.size?.scene as keyof IApparatusCountState] += 1
          }
          return pre
        }, this.apparatusCount)
    },
  },
})

export const useApparatusMonitorStore = defineStore(NAME.APPARATUS_MONITOR, {
  state: (): ApparatusMonitorState => {
    return {
      query: {
        isPersonal: false,
      },
    }
  },
  persist: true,
  actions: {
    setApparatusMonitor(result: Partial<ApparatusMonitorState>) {
      this.$state = {
        ...this.$state,
        ...result,
      }
    },
  },
})

export const useIpvmsStore = defineStore(NAME.APPARATUS_IPVMS, () => {
  // 当前用户是否存在 无卡关机
  const existShutdown = ref(false)

  const setExistShutdown = (value: boolean) => {
    existShutdown.value = value
  }
  const getExistShutdown = computed(() => existShutdown.value)
  return {
    existShutdown,
    setExistShutdown,
    getExistShutdown,
  }
})
